import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskProjectSummaryRoute: InvariantJiraRoute = {
	path: '/jira/servicedesk/projects/:projectKey/summary/:dashboardId?',
	name: 'servicedesk-project-summary',
};
